import { useState, useCallback, useEffect } from 'react';
import FilterContext from './Context';

const CaseListFiltersProvider = ({ children }) => {
    const [caseListFilters, setCaseListFilters] = useState({});

    const updateCaseFilters = (filterName, value) => {
        setCaseListFilters(prevFilters => ({
          ...prevFilters,
          [filterName]: value
        }))
    }

    return (
        <FilterContext.Provider value={{ caseListFilters, updateCaseFilters }}>
            {children}
        </FilterContext.Provider>
    )
}

export default CaseListFiltersProvider;


